export default __webpack_public_path__ + "ruby.icon-85c5569a89166aabce70967ee7895c77.png";